import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

/**
 * Returns a mutable Vector3 that orbits the origin in a tilted plane,
 * simulating a sun moving across the sky over `cycleDuration` seconds.
 *
 * The returned object reference is stable (never changes) — it is
 * mutated in-place each frame, so consumers should read it in their
 * own useFrame callbacks rather than reacting to prop changes.
 */
export function useSunCycle(cycleDuration = 300, tilt = 0.44): THREE.Vector3 {
  const sun = useRef(new THREE.Vector3(0.5, 0.3, 0.8));

  useFrame((state) => {
    const angle = (state.clock.elapsedTime / cycleDuration) * Math.PI * 2;
    // Orbit in the XZ plane, tilted so the sun rises above and dips below the horizon
    sun.current.set(
      Math.cos(angle),
      Math.sin(angle) * Math.sin(tilt),
      Math.sin(angle) * Math.cos(tilt),
    );
  });

  return sun.current;
}
